export function trackEvent(name, params = {}) {
    if (typeof window === "undefined") return;

    if (typeof window.gtag !== "function") {
        console.warn("gtag is not available", { event: name, params });
        return;
    }

    window.gtag("event", name, {
        ...params,
        timestamp: Date.now(),
    });
}